<template>
  <div class="viaggistandardpage-container">
    <v-simple-table dense class="standard-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center text-body-1" colspan="20">
              <strong>VIAGGI CON CARICO E A VUOTO</strong>
            </th>
          </tr>
          <tr>
            <th v-for="letter in letters" :key="letter" class="text-center">
              {{ letter }}
            </th>
            <th></th>
          </tr>

          <tr v-show="showHeader">
            <th class="text-center" v-for="({ text, colspan }, index) in headers" :key="index" :colspan="colspan">
              {{ text }}
            </th>
          </tr>

          <tr v-show="showSubheader">
            <th
              class="text-center text-caption text--secondary py-2"
              v-for="({ text, width }, index) in subheaders"
              :key="index"
              style="line-height: 10px"
              :width="width"
            >
              <small>{{ text }}</small>
            </th>
          </tr>
        </thead>
        <tbody>
          <template>
            <tr v-for="(row, index) in rows" :key="`row-${index}`">
              <td
                v-for="col in 'ABCDEFGHILMNOPQRSTU'.toLowerCase().split('')"
                :key="col"
                :class="`table-col table-col__${col}`"
              >
                <template v-if="Array.isArray(row[col])">
                  <div class="goods-container">
                    <div v-for="(e, jindex) in row[col]" :key="jindex" class="goods-cell">{{ e }}</div>
                  </div>
                </template>
                <template v-else>
                  {{ row[col] }}
                </template>
              </td>
              <td class="table-col table-col__via text-center">{{ row.via }}</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    journeys: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      letters: 'ABCDEFGHILMNOPQRSTU'.split(''),
      headers: [
        { text: 'data', colspan: 1 },
        { text: 'portata utile', colspan: 1 },
        { text: 'n. assi', colspan: 1 },
        { text: 'località di partenza', colspan: 1 },
        { text: 'tipologia di località di carico', colspan: 1 },
        { text: 'operazioni di carico alla partenza', colspan: 4 },
        { text: 'località di arrivo', colspan: 1 },
        { text: 'tipologia di località di scarico', colspan: 1 },
        { text: "operazioni di scarico all'arrivo", colspan: 2 },
        { text: 'distanza percorsa in km', colspan: 1 },
        { text: 'veicolo caricato su altro mezzo', colspan: 3 },
        {
          text: 'stati attraversati (in caso di viaggi internazionali)',
          colspan: 1,
        },
        { text: 'tipo viaggio*', colspan: 1 },
        { text: 'VIA', colspan: 1 },
      ],
      subheaders: [
        { text: 'gg/mm', width: '40px' },
        { text: 'rimorchio o semi-rimorchio, se agganciato', width: '1px' },
        { text: 'rimorchio o semi-rimorchio, se agganciato', width: '1px' },
        { text: 'comune e provincia o comune e stato estero', width: '200px' },
        { text: 'codice lista d', width: '1px' },
        {
          text: 'merce caricata codice lista a; (se viaggio a vuoto codice=0)',
          width: '1px',
        },
        { text: 'merce pericolosa codice lista b', width: '1px' },
        { text: 'peso della merce q.li', width: '1px' },
        { text: 'aspetto del carico codice lista c', width: '1px' },
        { text: 'comune e provincia o comune e stato estero', width: '200px' },
        { text: 'codice lista d', width: '1px' },
        {
          text: 'merce a bordo; barrare il numero corrispondente alla partita di merce',
          width: '1px',
        },
        {
          text: 'merce scaricata; indicare la quantità in q.li (se viaggio a vuoto codice=0)',
          width: '1px',
        },
        {
          text: 'tra la località di partenza e quella di arrivo',
          width: '1px',
        },
        { text: 'nave=1 treno=2', width: '1px' },
        {
          text: 'località di imbarco; comune e provincia o comune e stato estero',
          width: '1px',
        },
        {
          text: 'località di sbarco; comune e provincia o comune e stato estero',
          width: '1px',
        },
        {
          text: 'tra la località di partenza e quella di arrivo',
          width: '1px',
        },
        { text: 'mono=1 multi=2 vuoto=4', width: '5px' },
        { text: '', width: '1px' },
      ],
      showHeader: true,
      showSubheader: true,
    }
  },
  computed: {},
  // methods: {
  //   goods(journey) {
  //     const { is_empty, goods } = journey

  //     let g = [...new Array(3)].map(() => ({
  //       type: '',
  //       dangerous_type: '',
  //       aspect: '',
  //       onboard: '',
  //       loaded_weight: '',
  //       unloaded_weight: '',
  //       onboard_flag: ''
  //     }))

  //     if (is_empty) {
  //       g[0].type = 0
  //       g[0].unloaded_weight = 0
  //     } else {
  //       goods.forEach((item, index) => {
  //         g[index].type = item.type
  //         g[index].dangerous_type = item.dangerous_type
  //         g[index].aspect = item.aspect
  //         g[index].loaded_weight = item.loaded_weight
  //         g[index].unloaded_weight = item.unloaded_weight
  //         g[index].onboard_flag = item.unloaded_weight === 0 ? 'X' : ''
  //       })
  //     }

  //     return g
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.table-col {
  color: #333 !important;
  font-family: 'Roboto Mono', monospace;
  font-weight: 400;
}

.table-col {
  &__a,
  &__b,
  &__c,
  &__e,
  &__f,
  &__g,
  &__h,
  &__i,
  &__m,
  &__n,
  &__o,
  &__p,
  &__q,
  &__r,
  &__u {
    text-align: center;
  }

  &__f,
  &__g,
  &__h,
  &__i,
  &__n,
  &__o {
    padding: 0 !important;
    margin: 0;
  }

  &__a,
  &__via {
    padding: 0 8px !important;
  }
}

// .mono {
//   color: #333 !important;
//   font-family: 'Roboto Mono', monospace;
//   font-weight: 400;
// }

.standard-table {
  border: thin solid rgba(0, 0, 0, 0.12);
  td {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    font-size: 12px !important;
    color: #333 !important;
  }
  td:first-child {
    border-left: none;
  }
  th {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    padding: 0 2px !important;
  }
  th:first-child {
    border-left: none;
  }
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

.goods-td {
  padding: 0 !important;
  margin: 0;
}

.goods-container {
  width: 100%;

  .goods-cell {
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
    min-height: 24px;
    padding: 2px 0;
  }

  .goods-cell:last-child {
    border-bottom: none !important;
  }
}
</style>
